const _ = require('lodash');

function PickupAddressSearchService(Restangular, storeService) {
    this.storeService = storeService;

    this._storeRoute = Restangular.one('PickupStores');

    this._cache = {};

    this.searchModes = {
        suburbs: 'suburbs',
        stores: 'stores',
        states: 'states',
    };
}

PickupAddressSearchService.prototype.searchByPostcode = function (args) {
    if (!(args.postcode in this._cache)) {
        this._cache[args.postcode] = this._storeRoute.one('Search').get(args);
    }

    return this._cache[args.postcode];
};

PickupAddressSearchService.prototype.searchByGeolocation = function (position) {
    return this._storeRoute.one('Search').get(position);
};

PickupAddressSearchService.prototype.searchSuburbs = _.memoize(function (searchTerm) {
    return this.storeService.searchSuburbs(searchTerm);
});

PickupAddressSearchService.prototype.invalidate = function () {
    this._cache = {};
};

module.exports = PickupAddressSearchService;



// WEBPACK FOOTER //
// ./src/fulfilment/address/pickup-address-search.service.js